import React from "react";
import { LineChart } from "@mui/x-charts/LineChart";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Stack from "@mui/material/Stack";
import { statuses } from "../../../ApiSevices/DashboardApis";

interface LineChartProps {
    lineChartCountData: {
        categories: string[];
        series: { name: string; data: number[]; color: string }[];
    } | null;
    loading: boolean;
}

const LineChartComponent: React.FC<LineChartProps> = ({ lineChartCountData, loading }) => {
    return (
        <Box sx={{ position: "relative", width: "100%", height: 350, bgcolor: "white", p: 2, borderRadius: 2 }}>
            <Box sx={{ display: "flex", alignItems: "center", gap: 2, mt: 1 }}>
                {statuses?.map((status, index) => (
                    <Box key={index} sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
                        <Box
                            sx={{
                                width: 12,
                                height: 12,
                                backgroundColor: status.color,
                                borderRadius: 0.5,
                            }}
                        />
                        <Typography variant="body2" sx={{ fontSize: "11px" }}>
                            {status?.label}
                        </Typography>
                    </Box>
                ))}
            </Box>
            {lineChartCountData && (
                <>
                    <LineChart
                        series={lineChartCountData?.series?.map((s) => ({
                            ...s,
                            showMark: true, // Show markers
                            area: true, // Add background shading
                            stroke: s.color,
                            valueFormatter: (val) => (val === null ? "0" : val.toString()),
                        }))}
                        xAxis={[{ scaleType: "point", data: lineChartCountData?.categories }]}
                        height={350}
                        grid={{ vertical: true, horizontal: true }} // Add grid lines
                        sx={{ marginTop: '-30px' }}
                    />

                    {/* Legend Section */}
                    <Stack direction="row" spacing={2} justifyContent="center" mt={2}>
                        {lineChartCountData?.series?.map((s, index) => (
                            <Box key={index} sx={{ display: "flex", alignItems: "center" }}>
                                <Box sx={{ width: 12, height: 12, bgcolor: s?.color, borderRadius: "50%", mr: 1 }} />
                                <Typography variant="body2">{s?.name}</Typography>
                            </Box>
                        ))}
                    </Stack>
                </>
            )}
        </Box>
    );
};

export default LineChartComponent;
